export const NEW_OFFER = 1
export const DOCUMENT_UPDATE = 2
export const CHAT_EXPORTED = 3
export const HELPDESK = 4
export const LOGS_EXPORTED = 5
export const REPORT_EXPORTED = 7
export const SPEDILINK_RESIGNATION = 8
export const SPEDILINK_LINK_UNSHARED = 9
export const SPEDILINK_GROUP_UNSHARED = 10
